import { render, staticRenderFns } from "./UIFormRow.vue?vue&type=template&id=d52e9062&"
import script from "./UIFormRow.vue?vue&type=script&lang=ts&"
export * from "./UIFormRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports